export default "__VITE_ASSET__CzrWaqbO__"